import {format} from 'date-fns'
import {nanoid} from 'nanoid'
import {concat, from, of} from 'rxjs'
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators'
import {Epic, StateObservable} from 'redux-observable'

import {AppActions, RootState} from 'app/rootReducer'
import Toast from 'components/Basic/Toast'
import {translations} from 'definitions'
import {HTTP_STATUS_CODE} from 'definitions/constant'
import {i18n} from 'i18n'
import {PBFFService} from 'services/api'
import {withDownloadInProgressToast} from '../downloadInProgressToast'
import {
  downloadAnalyticsLogs,
  downloadAnalyticsLogsFailure,
  downloadAnalyticsLogsSuccess,
} from './actions'
import {DEFAULT_DATE_WITH_TIME_FORMAT} from 'definitions/constant'

export const analyticsLogsDownloadEpic: Epic<
  AppActions,
  AppActions,
  StateObservable<RootState>
> = action$ =>
  action$.pipe(
    filter(downloadAnalyticsLogs.match),
    switchMap(({payload}) => {
      const requestBody = {
        userEmail: payload?.userEmail,
        dateTime: format(new Date(), DEFAULT_DATE_WITH_TIME_FORMAT),
      }
      return from(PBFFService.downloadAnalyticsLogs(requestBody)).pipe(
        mergeMap(resp => {
          const {data, status} = resp
          const {fileUrl = ''} = data?.response || {}
          if (status === HTTP_STATUS_CODE.NO_CONTENT) {
            Toast({
              message: i18n.t('analytics:ANALYTICS_DOWNLOAD_NO_TRANSACTIONS', {
                userEmail: payload?.userEmail,
                interpolation: {escapeValue: false},
              }),
              type: 'info',
              customId: `transactions-download-no-results-${nanoid()}`,
              multipleToast: true,
            })
          }
          return [downloadAnalyticsLogsSuccess(fileUrl)]
        }),
        catchError(() => concat(of(downloadAnalyticsLogsFailure()))),
        withDownloadInProgressToast,
      )
    }),
  )

export const analyticsLogsDownloadFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(downloadAnalyticsLogsFailure.match),
    tap(() =>
      Toast({
        message: translations.UNKNOWN_ERROR,
        type: 'error',
        multipleToast: true,
      }),
    ),
    ignoreElements(),
  )

export const analyticsLogsDownloadEpics = [
  analyticsLogsDownloadEpic,
  analyticsLogsDownloadFailureEpic,
]
